import { render } from "./ResultsNavigation.vue?vue&type=template&id=40ed0796"
import script from "./ResultsNavigation.vue?vue&type=script&lang=js"
export * from "./ResultsNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__